import { request } from './client';

/**
 * Bulk team form, scoped and as of a point in time.
 *
 * This file used to carry an over-fetch: the API had no tournamentId, so it asked for six
 * times what it rendered, filtered by competition in the browser and discarded the rest.
 * That workaround is gone because the reason for it is - the endpoint now takes the
 * tournament and does the filtering in the query.
 *
 * `matchWeek` is not a filter. The server derives the form cutoff from it — the earliest
 * kick-off of that week — so a week's own fixtures never appear in their own form strips,
 * and revisiting a closed week shows what it showed at the time. The client deliberately
 * does not send a timestamp: the value has to be reproducible, and a browser clock is not.
 *
 * @param teamIds       team ids to fetch
 * @param tournamentId  required; the competition whose results count
 * @param matchWeek     required; the week being viewed, which fixes the cutoff
 * @param limit         how many results per collection (5 pick screen, 10 form table)
 * @returns object keyed by teamId
 */
export async function fetchTeamForms(teamIds, tournamentId, matchWeek, limit) {
  if (!teamIds || teamIds.length === 0) return {};

  const params = new URLSearchParams({
    teamIds: teamIds.join(','),
    tournamentId: String(tournamentId),
    matchWeek: String(matchWeek),
    limit: String(limit),
  });

  let forms;
  try {
    forms = await request(`/api/customer/teams/form?${params}`);
  } catch (err) {
    if (err.name === 'ApiError') {
      throw new Error(`Form request failed: ${err.status}`);
    }
    throw err;
  }

  const byTeamId = {};
  forms.forEach((f) => {
    byTeamId[f.teamId] = f;
  });
  return byTeamId;
}
